import { defineNuxtPlugin } from '#app'
import { AnalyticsService } from './analytics'
import type { AnalyticsServiceInterface } from './interfaces/analytics.service.interface';
declare module '#app' {
    interface NuxtApp {
        $analytics: AnalyticsServiceInterface;
    }
}


export default defineNuxtPlugin({
    name: "analytics",
    dependsOn: ['platform', 'webos-plugin'],
    setup: async (nuxtApp) => {
        const { $domains, $fire, $platform } = useNuxtApp();

        const analytics = new AnalyticsService(
            $fire,
            $domains,
            $platform,
        );

        nuxtApp.provide('analytics', analytics);
    }
});